import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import moment from "moment";

@Component({
    selector: "app-submit-success-dialog",
    templateUrl: "./submit-success-dialog.component.html",
    standalone: false
})
export class SubmitSuccessDialogComponent {
	email: string;
	onOperation: boolean;
	responseTime: string = "5 - 20";
	redirect: string | null = ''
	constructor(
		@Inject(MAT_DIALOG_DATA) data: any,
		private router: Router 
		// gtmService: GoogleTagManagerService,
	) {
		// gtmService.pushTag({
		// 	event: "car_leads",
		// });
		this.email = data.email;
		this.onOperation = this.isOnOperation();
		this.redirect = data.redirect
	}

	private isOnOperation() {
		let today = moment();
		let day = today.day();
		if (day == 6 || day == 0) this.responseTime = "5 - 30";

		let before = moment().set({
			hour: 22,
			minute: 0,
			second: 0,
			millisecond: 0,
		});
		let after = moment().set({
			hour: 10,
			minute: 0,
			second: 0,
			millisecond: 0,
		});

		return today.isBetween(after, before);
	}

	onClose(){
		this.router.navigate(["/transactions"]);

	}
}
